import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { APIResponseWrapper } from '../models/common/api-response-wrapper';
import { WorkbenchDashboard, WorkbenchPreference } from './dashboard-workbench.model';

@Injectable({
    providedIn: 'root'
})
export class DashboardWorkbenchService {
    private readonly restApiUrl = `${environment.restApiUrl}workbench`;

    constructor(private http: HttpClient) { }

    getDashboard(companyId: number, customerId: number, fromDate?: Date, toDate?: Date): Observable<WorkbenchDashboard> {
        let params = new HttpParams()
            .set('companyId', companyId)
            .set('customerId', customerId);

        if (fromDate) {
            params = params.set('fromDate', this.toApiDate(fromDate));
        }
        if (toDate) {
            params = params.set('toDate', this.toApiDate(toDate));
        }

        return this.http
            .get<APIResponseWrapper<WorkbenchDashboard>>(`${this.restApiUrl}/dashboard`, { params })
            .pipe(map(response => response.data));
    }

    getPreference(companyId: number, scopeType: string, roleName?: string, customerId?: number): Observable<WorkbenchPreference> {
        let params = new HttpParams()
            .set('companyId', companyId)
            .set('scopeType', scopeType);
        if (roleName) {
            params = params.set('roleName', roleName);
        }
        if (customerId) {
            params = params.set('customerId', customerId);
        }
        return this.http
            .get<APIResponseWrapper<WorkbenchPreference>>(`${this.restApiUrl}/preferences`, { params })
            .pipe(map(response => response.data));
    }

    savePreference(preference: WorkbenchPreference): Observable<WorkbenchPreference> {
        return this.http
            .put<APIResponseWrapper<WorkbenchPreference>>(`${this.restApiUrl}/preferences`, preference)
            .pipe(map(response => response.data));
    }

    private toApiDate(date: Date): string {
        return date.toISOString().slice(0, 10);
    }
}
